export default __webpack_public_path__ + "static/media/michael-lai-bw.5dfd600d.png";